// Polyfills
import 'es6-object-assign/auto';
import 'core-js/fn/array/includes';
import 'core-js/fn/promise/finally';
import 'intl'; // For Safari 9

import React from 'react';
import ReactDOM from 'react-dom';

import analytics from '../lib/analytics';
import AppStateHOC from '../lib/app-state-hoc.tsx';
import BrowserModalComponent from '../components/browser-modal/browser-modal.tsx';
import {setAppElement} from 'react-modal';
import supportedBrowser from '../lib/supported-browser';

import styles from './index.css';

// Register "base" page view
analytics.pageview('/');

const appTarget = document.createElement('div');
appTarget.className = styles.app;
document.body.appendChild(appTarget);

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js').then(registration => {
            // eslint-disable-next-line no-console
            console.log('SW registered: ', registration);
        })
            .catch(registrationError => {
            // eslint-disable-next-line no-console
                console.log('SW registration failed: ', registrationError);
            });
    });
}

if (supportedBrowser()) {
    // require needed here to avoid importing unsupported browser-crashing code
    // at the top level
    // eslint-disable-next-line global-require
    require('./render-gui').default(appTarget);

} else {
    setAppElement(appTarget);
    const WrappedBrowserModalComponent = AppStateHOC(BrowserModalComponent, true /* localesOnly */);
    const handleBack = () => {};

    ReactDOM.render(<WrappedBrowserModalComponent onBack={handleBack} />, appTarget);
}
